import styled from 'styled-components'

const EquipmentSelectorStyled = styled.div``
export default EquipmentSelectorStyled
